export default "__VITE_ASSET__BkTYQVGJ__"